import React from 'react'

import PropTypes from 'prop-types'
import VideoDataGetter from 'experienceComponents/VideoDataGetter'
import VideoDataSetter from 'experienceComponents/VideoDataSetter'
import { BodyCopy } from 'secondstep-components'
import {
  ContentWrapper,
  RatioWrapper,
  VideoWrapper,
} from 'components/InlineVideo/component.styles'

import { Column, Row, Wrapper } from './component.styles'

const MediaBodyCopyComponent = props => {
  const {
    locale,
    videoEntryId,
    bodyCopy,
    id,
    mediaVideoUrl,
    mediaVideoUrlExtended,
    mediaPosterUrl,
    mediaTranscriptSource,
    mediaTranscriptExtended,
    mediaTracks = [],
  } = props || {}

  const hasDirectVideoData = !!mediaVideoUrl

  return (
    <Wrapper dataTestId={`media-copy-body-${id}`}>
      <Row>
        <Column>
          <ContentWrapper>
            <RatioWrapper>
              <VideoWrapper>
                {videoEntryId ? (
                  <VideoDataGetter
                    entryId={videoEntryId}
                    refetchLocale={locale}
                  />
                ) : (
                  hasDirectVideoData && (
                    <VideoDataSetter
                      id={id}
                      poster={mediaPosterUrl}
                      refetchLocale={locale}
                      tracks={JSON.stringify(mediaTracks)}
                      transcriptExtended={mediaTranscriptExtended}
                      transcriptSource={mediaTranscriptSource}
                      videoUrl={mediaVideoUrl}
                      videoUrlExtended={mediaVideoUrlExtended}
                    />
                  )
                )}
              </VideoWrapper>
            </RatioWrapper>
          </ContentWrapper>
        </Column>

        <Column>
          <BodyCopy>{bodyCopy}</BodyCopy>
        </Column>
      </Row>
    </Wrapper>
  )
}

MediaBodyCopyComponent.propTypes = {
  bodyCopy: PropTypes.string,
  id: PropTypes.string,
  locale: PropTypes.string,
  mediaPosterUrl: PropTypes.string,
  mediaTracks: PropTypes.array,
  mediaTranscriptExtended: PropTypes.object,
  mediaTranscriptSource: PropTypes.object,
  mediaVideoUrl: PropTypes.string,
  mediaVideoUrlExtended: PropTypes.string,
  videoEntryId: PropTypes.string,
}

export default MediaBodyCopyComponent
